import React from 'react'
import SubmitButton from 'components/common/submitButton'
import clsx from 'clsx'
import EstablishmentCreateView from './establishmentCreateView'
import { Typography } from '@material-ui/core'
import { useStyles } from './styles.css'
import { Trans } from 'react-i18next'
import DunsCompleteForm, { DunsCompleteFormState } from '../../forms/establishment/dunsCompleteForm'
import SignUpContent from '../../layouts/components/signUpContent'
import SignUpActions from 'components/layouts/components/signUpActions'

interface Props {
    step: number
    steps: number
    onSubmit: (values: DunsCompleteFormState) => void
    inProgress: boolean
    initialValues: DunsCompleteFormState
}

const EstablishmentEuropeanVATCompleteView: React.FC<Props> = ({ children, step, steps, ...formData }) => {
    const classes = useStyles()
    return (
        <DunsCompleteForm {...formData} type="europeanVat">
            {(content, actions) => (
                <>
                    <SignUpContent>
                        <EstablishmentCreateView step={step} steps={steps}>
                            <Typography variant="h1" color="textSecondary" className={classes.title}>
                                <Trans i18nKey="views.establishment.europeanVat.title" />
                            </Typography>
                            <Typography className={classes.description}>
                                <Trans i18nKey="views.establishment.europeanVat.descriptionComplete" />
                            </Typography>
                            {content}
                        </EstablishmentCreateView>
                    </SignUpContent>
                    <SignUpActions>
                        {actions.map((action, index) => (
                            <SubmitButton
                                key={index}
                                variant="contained"
                                color="primary"
                                {...action}
                                className={clsx(action.className)}
                            >
                                <Trans i18nKey="views.establishment.europeanVat.confirm" />
                            </SubmitButton>
                        ))}
                    </SignUpActions>
                </>
            )}
        </DunsCompleteForm>
    )
}

export default EstablishmentEuropeanVATCompleteView
